// The sticky navigation setting is kept in this browser only, so reading it must survive blocked storage.
const STORAGE_KEY = "stickyNavigation";

export const isStickyNavigation = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch (error) {
    return false;
  }
};

export const applyStickyNavigation = (body) => {
  body.classList.toggle("sticky-navigation", isStickyNavigation());
};

export const setStickyNavigation = (enabled) => {
  try {
    localStorage.setItem(STORAGE_KEY, enabled);
  } catch (error) {
    // Storage is blocked: the setting then lasts for this page only.
  }
  document.body.classList.toggle("sticky-navigation", enabled);
};
